import React from 'react';
import ClientFeeItem from '../Domain/ClientFeeItem';
import ProjectItem from '../Domain/ProjectItem';
import dateTimeHelper from '../Helpers/datetimeHelper';
import serviceHelper from '../Helpers/serviceHelper';
import AuthService from './authService';
import ProjectChangeItem from '../Domain/ProjectChangeItem';
import SearchParams from '../Elements/SearchParams';
import ProjectSearchParams from '../Contents/Operations/Projects/ProjectSearchParams';

export default class OperationsProjectService extends React.Component {
  static GetProjectList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(
      searchItem,
      ProjectSearchParams,
      orderById,
      orderDir,
      pageNumber,
      numberOfElements
    );
    const url = `/api/Project/GetAllBySearchingAsync?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static GetProjectById(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/Project/GetProjectById/${id}`);
  }

  static GetIsProjectInvoicedById(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/Project/GetIsProjectInvoicedByIdAsync/${id}`);
  }

  static ConvertDBItemList(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new ProjectItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static ConvertPricingDBItemList(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new ClientFeeItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static GetClientFeeList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    return AuthService.getInstance().CallBackendFunction(
      `/api/Project/GeClientFeeListById?orderBy=${orderById}&orderDirection=${orderDir}&pageNumber=${pageNumber}&numberOfElements=${numberOfElements}&id=${searchItem.CfServiceId}&clearCache=${clearCache}`
    );
  }

  static EditProject(item) {
    const outsourcingOfficeIds = item.OutsourcingOfficeIds;
    item = serviceHelper.ConvertAllPropertyToString(item);
    item.OutsourcingOfficeIds = outsourcingOfficeIds || [];

    if (item.CfId === '') {
      const JSONItem = JSON.stringify(item);
      const url = '/api/Project/PostProjectAsync';
      return AuthService.getInstance().CallBackendFunctionPost(url, JSONItem);
    }
    const JSONItem = JSON.stringify(item);
    const url = '/api/Project/EditProjectAsync';
    return AuthService.getInstance().CallBackendFunctionPut(url, JSONItem);
  }

  static async GetProjectListByClientId(clientId, isForExcelDataExport = false) {
    const authService = AuthService.getInstance();

    let url = '/api/Project/GetProjectsByClientIdAsync';

    url += (parseInt(clientId) > 1 ? `/${clientId}` : '/0') + `?isForExcelDataExport=${isForExcelDataExport}`;

    return authService.CallBackendFunction(url);
  }

  static ConvertProjectChangeDBItem(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new ProjectChangeItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }
}
